import {
  AppDispatch,
  getDeviceBrandListForSelect,
  getDeviceBrandListForSelectRequest,
} from "@src/redux";
import { Form, FormInstance, Select } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

interface DeviceBrandComponentProps {
  form: FormInstance;
}

const DeviceBrand: React.FC<DeviceBrandComponentProps> = ({ form }) => {
  const deviceType = Form.useWatch("deviceType", form);
  const { result: deviceBrandResult, loading: loading } = useSelector(
    getDeviceBrandListForSelect
  );
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (deviceType) {
      dispatch(
        getDeviceBrandListForSelectRequest({
          filter: {
            deviceType: deviceType,
          },
        })
      );
    }
  }, [deviceType]);

  return (
    <Form.Item
      name="deviceBrand"
      label="Brand"
      rules={[
        {
          required: true,
          message: "Please select the brand",
        },
      ]}
    >
      <Select
        placeholder=""
        options={deviceType ? deviceBrandResult?.items : []}
        fieldNames={{ label: "name", value: "id" }}
        notFoundContent={loading ? "Loading..." : "No data"}
        loading={loading}
      />
    </Form.Item>
  );
};

export default DeviceBrand;
